export default __webpack_public_path__ + "static/media/error_img.2cd0e51b.png";